import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useSimpleConfirmDialog } from 'containers/ConfirmDialog/useSimpleConfirmDialog';
import { useNotifications } from 'utils/hooks/useNotifications';

type ConfirmedDeleteOptions<T> = {
  header: string;
  message: (item: T) => string;
  deleteItem: (item: T) => Promise<void>;
  successMessage: string;
};

/** Confirm, delete, then notify — the delete flow shared by the admin tables. */
export const useConfirmedDelete = <T>({
  header,
  message,
  deleteItem,
  successMessage,
}: ConfirmedDeleteOptions<T>) => {
  const confirmDeleteDialog = useSimpleConfirmDialog();
  const { showNotification } = useNotifications();

  const requestDelete = useStableCallback(async (item: T) => {
    const confirmed = await confirmDeleteDialog.show({
      header,
      subHeader: message(item),
      btnConfirm: 'Delete',
      btnSecondaryConfirm: 'Cancel',
    });
    if (!confirmed) {
      return;
    }
    await deleteItem(item);
    showNotification({ type: 'success', message: successMessage });
  });

  return { confirmDeleteDialog, requestDelete };
};
